import { motion } from "framer-motion";

export const MaskLine = ({ children, delay = 0, className = "" }) => (
    <span className={`mask-reveal ${className}`} style={{ display: "block" }}>
        <motion.span
            style={{ display: "inline-block" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ y: 30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1], delay }}
    >
        {children}
    </motion.div>
);

export const ChapterHeader = ({ num, title, kicker, testId }) => (
    <div className="border-t border-white/10 pt-6 mb-10 md:mb-14" data-testid={testId}>
        <div className="flex items-baseline gap-6 flex-wrap">
            <span className="chapter-num">CH. {num}</span>
            <span className="chapter-num text-white/30">/</span>
            <span className="chapter-num">{kicker}</span>
        </div>
        <h2 className="font-mono uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight mt-4">
            {title}
        </h2>
    </div>
);
